const config = {
  calendar: '行事历',
  recent_interview: '最近面试',
  Month: '月份',
  Week: '周',
  Day: '日',
  Agenda: '列表',
  today: '今天',
};

export default config;
